{
    "SortAsc1Label": "1st Ascending",
    "SortDsc1Label": "1st Descending",
    "SortAsc2Label": "2nd Ascending",
    "SortDsc2Label": "2nd Descending",
    "SortAsc3Label": "3rd Ascending",
    "SortDsc3Label": "3rd Descending",
    "SortNoneLabel": "[Not Sorted By]",
    "SortAsc1Tooltip": "Primarily sort report rows ascending by the selected statistic/field.",
    "SortDsc1Tooltip": "Primarily sort report rows descending by the selected statistic/field.",
    "SortAsc2Tooltip": "Secondarily sort ascending by the selected statistic/field.",
    "SortDsc2Tooltip": "Secondarily sort descending by the selected statistic/field.",
    "SortAsc3Tooltip": "Sort report rows 3rd-ascending by the selected statistic/field.",
    "SortDsc3Tooltip": "Sort report rows 3rd-descending by the selected statistic/field.",
    "SortNoneTooltip": "Don't sort report rows by the selected statistic/field.",
    "NAME": "SortList"
}